import type { Ref } from 'vue'
import { SfLog } from '@app/adapters/logger'
import type { GraphData } from '@app/application/report/screens/graphs-echarts/types'
import type { ChartRenderOptions } from '@app/application/report/screens/graphs-echarts/utils/build-chart-option'

import { onUnmounted, watchEffect } from 'vue'

import { EchartsChartManager } from './echarts-chart-manager'

export function useEchartsChart(
  containerRef: Ref<HTMLElement | null>,
  graphData: Ref<GraphData | null>,
  options?: Ref<ChartRenderOptions>,
  onSeriesClick?: (params: { seriesName?: string; name?: string }) => void
): void {
  const manager = new EchartsChartManager()

  watchEffect(() => {
    if (containerRef.value && graphData.value) {
      manager
        .init(containerRef.value, graphData.value, {
          ...(options?.value ?? {}),
          onSeriesClick,
        })
        .catch((error) => {
          SfLog.error('Failed to render ECharts:', { error })
        })
    } else {
      manager.dispose()
    }
  })

  onUnmounted(() => {
    manager.dispose()
  })
}
